import store from "../store";

export default function hasAuth(context:any) {
    const router = context.router;
    const resource = context.to.params.eventUrl;
    store.dispatch("API_CALL", { method: "get", url: `/events/verify/${resource}`}).then((res) => {
        if(!localStorage.getItem("access_token")) return router.push({ name: "Authenticate", params: { eventUrl: resource }})
        return context.next();
    }).catch((err) => {
        return context.next({ name: "Home" });
    })
}